<template>
  <div class="home-quotes">
    <div class="grid-container">
      <div class="grid-x grid-margin-x medium-up-2 align-center">
        <div class="cell">
          <div class="home-quotes-photos">
            <div
              class="home-quotes-photos__tagline"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              Hear from a diverse team that is dedicated to our policyholders.
            </div>
            <div
              class="photo-slider"
              data-slider
              data-aos="fade-right"
              data-aos-duration="1000"
              data-aos-delay="400"
              data-aos-id="photo-slider"
            >
              <div class="photo-slider__inner">
                <div class="photo-slider__double-quote">
                  &ldquo;
                </div>
                <div
                  class="photo-slider__photos"
                  data-slider-photos
                >
                  <div
                    v-for="(quote, index) in $quotes"
                    :key="quote.name"
                    class="photo-slider__photo"
                    :style="{ display: index === 0 ? 'block' : 'none'}"
                    data-slider-photo
                  >
                    <img :src="quote.photo" />
                  </div>
                </div>
              </div>
              <div class="photo-slider__controls">
                  <div
                    v-for="(quote, index) in $quotes"
                    :key="quote.name"
                    class="photo-slider__control"
                    :class="{ active: index === sliderIndex }"
                    @click="handleSliderControlClick(index)"
                  >
                  </div>
              </div>
            </div>
          </div>
        </div>
        <div class="cell">
          <div
            class="home-quotes-content"
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-delay="800"
          >
            <div class="home-quotes-content__authors">
              <div
                v-for="(quote, index) in $quotes"
                :key="quote.name"
                class="home-quotes-content__author"
                :style="{ display: index === 0 ? 'block' : 'none'}"
                data-slider-author
              >
                {{ quote.name }}<br/>{{ quote.position }}
              </div>
            </div>
            <div class="home-quotes-content__quotations">
              <div
                v-for="(quote, index) in $quotes"
                :key="quote.name"
                class="home-quotes-content__quotation"
                :style="{ display: index === 0 ? 'block' : 'none'}"
                data-slider-quote
              >
                <span>&ldquo;{{ quote.quote }}&rdquo;</span>
                <div class="home-quotes-content__action">
                  <router-link
                    to="/leadership"
                    class="button large hollow red"
                  >
                    See more from our team.
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';

export default {
  name: 'HomeQuotes',
  data: function () {
    return {
      sliderInitialized: false,
      sliderIndex: 0,
      sliderInterval: null
    };
  },
  mounted () {
    this.setQuoteHeights();
    this.handleDebouncedResize = debounce(this.setQuoteHeights, 50);
    window.addEventListener('resize', this.handleDebouncedResize);
    document.addEventListener('aos:in:photo-slider', this.initializeSlider);
  },
  beforeDestroy () {
    clearInterval(this.sliderInterval);
    window.removeEventListener('resize', this.handleDebouncedResize);
    document.removeEventListener('aos:in:photo-slider', this.initializeSlider);
  },
  methods: {
    initializeSlider () {
      if (this.sliderInitialized) return;
      this.initializeSliderAutoplay();
      this.sliderInitialized = true;
    },
    selectSlide (index) {
      if (this.sliderIndex === index) return;

      this.sliderIndex = index;
      const $slider = $('[data-slider]');
      const $photos = $('[data-slider-photos]');
      const $previousPhoto = $('[data-slider-photo]:visible');
      const $nextPhoto = $('[data-slider-photo]').eq(index);
      const $previousAuthor = $('[data-slider-author]:visible');
      const $nextAuthor = $('[data-slider-author]').eq(index);
      const $previousQuote = $('[data-slider-quote]:visible');
      const $nextQuote = $('[data-slider-quote]').eq(index);

      $photos.css('height', $previousPhoto.height() + 'px');
      $slider.addClass('animating');
      $nextPhoto.css('z-index', '1');
      $nextPhoto.fadeIn(400, function () {
        $previousPhoto.hide();
        $nextPhoto.css('z-index', '');
        $slider.removeClass('animating');
        $photos.css('height', '');
      });

      $previousAuthor.fadeOut(200, function () {
        $nextAuthor.fadeIn(200);
      });

      $previousQuote.fadeOut(200, function () {
        $nextQuote.fadeIn(200);
      });
    },
    handleSliderControlClick (index) {
      clearInterval(this.sliderInterval);
      this.selectSlide(index);
    },
    initializeSliderAutoplay () {
      this.sliderInterval = setInterval(
        () => {
          const nextIndex = (
            this.sliderIndex === this.$quotes.length - 1
              ? 0
              : this.sliderIndex + 1
          );
          this.selectSlide(nextIndex);
        },
        10000
      );
    },
    setQuoteHeights () {
      const quoteHeightMax = (
        $('[data-slider-quote]').toArray().reduce(
          (max, el) => $(el).height() > max ? $(el).height() : max,
          0
        )
      );
      $('[data-slider-quote]').each((index, element) => {
        $(element).css('height', quoteHeightMax + 'px');
      });
    }
  }
};
</script>
